import { Box, Link, LinkTypeMap, styled } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';

interface AdditionalLinkStyledProps {
  $capitalize: boolean;
  $underline: boolean;
}

export const LinkStyled = styled(Link)<AdditionalLinkStyledProps>(
  ({ theme, $capitalize, $underline }) => ({
    textTransform: $capitalize ? ('capitalize' as const) : ('none' as const),
    padding: 0,
    '&:focus': {
      outline: `0.2rem solid ${theme.palette.primary.main}`,
      textDecoration: $underline
        ? theme.typography.link.textDecorationLine
        : ('none' as const),
    },
    '&:disabled': {
      color: theme.palette.grey[400],
      textDecoration: 'none',
      cursor: 'default',
    },
    display: 'inline-flex',
    alignItems: 'center',
    wordBreak: 'break-word',
  })
) as OverridableComponent<LinkTypeMap<AdditionalLinkStyledProps, 'a'>>;

export const IconWrapperStyled = styled(Box)(({ theme }) => ({
  color: theme.palette.primary.main,
  display: 'flex',
}));
